import { tr } from "../i18n/LanguageContext";
// Clean MVP - Data comes from database API
// These exports are kept for compatibility but are empty

export const mockEvents = [];

export const mockOrganizers = [];

export const mockBlogPosts = [];

// Unified, canonical practice type list used everywhere in the app:
//   - Organizer profile "Мои практики" (checkboxes / pills)
//   - Event creation "Выберите тип практики" (dropdown)
//   - Filters on the /events page
// Adding or removing a practice here is the ONLY place any UI needs to change.
export const practiceTypes = [
  { value: "meditation", label: "Медитация" },
  { value: "yoga", label: "Йога" },
  { value: "breathwork", label: "Дыхательные практики" },
  { value: "sound-healing", label: "Звуковая терапия" },
  { value: "body-practices", label: "Телесные практики" },
  { value: "dance-ecstatic", label: "Танцевальные и экстатические практики" },
  { value: "energy-practices", label: "Энергетические практики" },
  { value: "shamanic", label: "Шаманские практики" },
  { value: "tantra", label: "Тантра" },
  { value: "retreats", label: "Ретриты" },
  { value: "ceremony", label: "Церемонии" },
  { value: "art-therapy", label: "Арт-терапия" },
  { value: "qigong", label: "Цигун" },
  { value: "transformation-games", label: "Трансформационные игры" },
];

const legacyPracticeLabels = {
  energy: "Энергетические практики",
  "energy-healing": "Энергетические практики",
  kabbalah: "Каббала",
};

export const getPracticeLabel = (value) =>
  tr(practiceTypes.find((p) => p.value === value)?.label || legacyPracticeLabels[value] || value);


// EU Countries with their major cities (in Russian)
export const euCountriesWithCities = {
  "Австрия": {
    en: "Austria",
    cities: ["Вена", "Зальцбург", "Грац", "Инсбрук", "Линц"]
  },
  "Бельгия": {
    en: "Belgium", 
    cities: ["Брюссель", "Антверпен", "Гент", "Брюгге", "Льеж"]
  },
  "Болгария": {
    en: "Bulgaria",
    cities: ["София", "Пловдив", "Варна", "Бургас", "Русе"]
  },
  "Хорватия": {
    en: "Croatia",
    cities: ["Загреб", "Сплит", "Риека", "Осиек", "Задар"]
  },
  "Кипр": {
    en: "Cyprus",
    cities: ["Никосия", "Лимассол", "Ларнака", "Пафос", "Фамагуста"]
  },
  "Чехия": {
    en: "Czech Republic",
    cities: ["Прага", "Брно", "Острава", "Пльзень", "Либерец"]
  },
  "Дания": {
    en: "Denmark",
    cities: ["Копенгаген", "Орхус", "Оденсе", "Ольборг", "Эсбьерг"]
  },
  "Эстония": {
    en: "Estonia",
    cities: ["Таллин", "Тарту", "Пярну", "Нарва", "Кохтла-Ярве"]
  },
  "Финляндия": {
    en: "Finland",
    cities: ["Хельсинки", "Тампере", "Турку", "Оулу", "Лахти"]
  },
  "Франция": {
    en: "France",
    cities: ["Париж", "Лион", "Марсель", "Ницца", "Тулуза", "Страсбург", "Нант", "Бордо"]
  },
  "Германия": {
    en: "Germany",
    cities: ["Берлин", "Мюнхен", "Гамбург", "Кёльн", "Франкфурт", "Штутгарт", "Дрезден", "Дюссельдорф"]
  },
  "Греция": {
    en: "Greece",
    cities: ["Афины", "Салоники", "Патры", "Ираклион", "Лариса"]
  },
  "Венгрия": {
    en: "Hungary",
    cities: ["Будапешт", "Дебрецен", "Сегед", "Мишкольц", "Печ"]
  },
  "Ирландия": {
    en: "Ireland",
    cities: ["Дублин", "Корк", "Лимерик", "Голуэй", "Уотерфорд"]
  },
  "Италия": {
    en: "Italy",
    cities: ["Рим", "Милан", "Неаполь", "Турин", "Флоренция", "Болонья", "Венеция", "Палермо"]
  },
  "Латвия": {
    en: "Latvia",
    cities: ["Рига", "Даугавпилс", "Лиепая", "Елгава", "Юрмала"]
  },
  "Литва": {
    en: "Lithuania",
    cities: ["Вильнюс", "Каунас", "Клайпеда", "Шяуляй", "Паневежис"]
  },
  "Люксембург": {
    en: "Luxembourg",
    cities: ["Люксембург", "Эш-сюр-Альзетт", "Дифферданж", "Дюделанж"]
  },
  "Мальта": {
    en: "Malta",
    cities: ["Валлетта", "Биркиркара", "Моста", "Слима", "Сан-Гильян"]
  },
  "Нидерланды": {
    en: "Netherlands",
    cities: ["Амстердам", "Роттердам", "Гаага", "Утрехт", "Эйндховен", "Тилбург", "Гронинген"]
  },
  "Польша": {
    en: "Poland",
    cities: ["Варшава", "Краков", "Гданьск", "Вроцлав", "Познань", "Лодзь", "Щецин"]
  },
  "Португалия": {
    en: "Portugal",
    cities: ["Лиссабон", "Порту", "Брага", "Коимбра", "Фуншал"]
  },
  "Румыния": {
    en: "Romania",
    cities: ["Бухарест", "Клуж-Напока", "Тимишоара", "Яссы", "Констанца"]
  },
  "Словакия": {
    en: "Slovakia",
    cities: ["Братислава", "Кошице", "Прешов", "Нитра", "Жилина"]
  },
  "Словения": {
    en: "Slovenia",
    cities: ["Любляна", "Марибор", "Целе", "Крань", "Веленье"]
  },
  "Испания": {
    en: "Spain",
    cities: ["Мадрид", "Барселона", "Валенсия", "Севилья", "Сарагоса", "Малага", "Бильбао"]
  },
  "Швеция": {
    en: "Sweden",
    cities: ["Стокгольм", "Гётеборг", "Мальмё", "Упсала", "Линчёпинг"]
  }
};

// Get list of all countries
export const countries = ["Все страны", ...Object.keys(euCountriesWithCities).sort()];

// Get cities for a specific country
export const getCitiesForCountry = (country) => {
  if (country === "Все страны" || !country) {
    return ["Все города"];
  }
  const countryData = euCountriesWithCities[country];
  return countryData ? ["Все города", ...countryData.cities] : ["Все города"];
};

// Helper function to get all cities (for backward compatibility)
export const cities = [
  "Все города", 
  "Онлайн",
  ...Object.values(euCountriesWithCities).flatMap(country => country.cities).sort()
];
